exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-swiper {\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/swiper.less
// module id = 265
// module chunks = 0